import { BaseClient } from '../client';
import { veiculoAno } from '../offer/offer.mocks';
import { TVeiculoAno } from '../offer/offer.types';

export const getVehicleYears = async (idVehicleModel: number | string) => {
	if (process.env.NODE_ENV === 'development') {
		const response: TVeiculoAno[] = [veiculoAno];
		return response;
	}
	try {
		const response = await BaseClient.get<TVeiculoAno[]>(`/VeiculoAnos/GetVeiculoAnosPorIdModelo/${idVehicleModel}`).then((response) => response.data);

		return response;
	} catch (error) {
		throw error;
	}
};
